export { Hero } from './container';
export type { ContainerProps as Props } from './types';
